import { useAutoFetchLocation } from "~/composables/location/useAutoFetchLocation";

export default defineNuxtPlugin(() => {
  if (process.client) {
    const { checkIfLocationsAreSame } = useAutoFetchLocation()

      ; (window as any).wakeupSleepScreen = async (eventName: string) => {
        console.log('📲 Wakeup/Sleep Event from Android:', eventName)

        if (eventName === 'SCREEN_UNLOCK' || eventName === 'SCREEN_LOCK') {
          console.log(`📲 ${eventName} event triggered`)

          try {
            await checkIfLocationsAreSame()
            console.log('[AutoFetchLocation] Location check completed successfully')
          } catch (err) {
            console.error('[AutoFetchLocation] Error during location check:', err)
          }
        }
      }
  }
})
